import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { MainContext } from '@blaze-cms/nextjs-components';
import { VariantContext } from '../../ListFactory';
import BuildPBComponents from '../../../../hooks/helpers/buildPBComponents';
import Banner from '../../../Banner';
import { parsePropsToDisplay, shouldRenderWaypoint } from '../../../../helpers';
const FullRenderItem = props => {
  const {
    isInfinite,
    pageBuilderComponents,
    entityProps,
    propsToDisplay,
    entity,
    index,
    itemId,
    listTotal,
    initialOffset,
    currentListLength,
    triggerInfiniteScroll,
    parent,
    pageBuilderID,
    displayCount,
    shouldRenderBanner,
    bannerProps,
    bannerIndex
  } = props;
  const {
    hasGTM
  } = useContext(MainContext);
  const VariantComponent = useContext(VariantContext);
  if (!pageBuilderComponents) return null;
  const parsedPropsToDisplay = parsePropsToDisplay(entityProps, propsToDisplay);
  const currentItemIndex = initialOffset + index;
  const renderWaypoint = isInfinite && shouldRenderWaypoint(index, currentListLength, currentItemIndex, listTotal);
  const defaultContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "list__item list__item--full"
  }, BuildPBComponents(pageBuilderComponents, {
    parent: _objectSpread(_objectSpread({}, parent), {}, {
      itemId,
      itemEntity: entity
    }),
    hasGTM,
    pageBuilderID
  })), !VariantComponent && !!parsedPropsToDisplay.length && /*#__PURE__*/React.createElement(React.Fragment, null, parsedPropsToDisplay.map(prop => prop ? /*#__PURE__*/React.createElement("span", {
    key: prop
  }, prop) : null)));
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderWaypoint && /*#__PURE__*/React.createElement(Waypoint, {
    onEnter: triggerInfiniteScroll
  }), displayCount && /*#__PURE__*/React.createElement("div", {
    className: "heading heading--section heading--section--count"
  }, /*#__PURE__*/React.createElement("span", {
    className: "section-number"
  }, currentItemIndex + 1), /*#__PURE__*/React.createElement("span", {
    className: "section-total"
  }, "/", listTotal)), VariantComponent ? /*#__PURE__*/React.createElement(VariantComponent, props, defaultContent) : defaultContent, shouldRenderBanner && /*#__PURE__*/React.createElement(Banner, _extends({}, bannerProps, {
    renderCounter: bannerIndex
  })));
};
FullRenderItem.propTypes = {
  pageBuilderComponents: PropTypes.array,
  entityProps: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired,
  currentListLength: PropTypes.number.isRequired,
  listTotal: PropTypes.number.isRequired,
  initialOffset: PropTypes.number.isRequired,
  displayCount: PropTypes.bool.isRequired,
  triggerInfiniteScroll: PropTypes.func,
  entity: PropTypes.string.isRequired,
  pageBuilderID: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isInfinite: PropTypes.bool.isRequired,
  shouldRenderBanner: PropTypes.bool.isRequired,
  bannerIndex: PropTypes.number.isRequired,
  propsToDisplay: PropTypes.array,
  data: PropTypes.array,
  itemsToDisplay: PropTypes.array,
  bannerProps: PropTypes.object
};
FullRenderItem.defaultProps = {
  pageBuilderComponents: null,
  data: [],
  propsToDisplay: [],
  itemsToDisplay: [],
  triggerInfiniteScroll: null,
  bannerProps: null
};
export default FullRenderItem;
//# sourceMappingURL=FullRenderItem.js.map